import {
  Children,
  isValidElement,
} from 'react';
import Tooltip from './Tooltip';

export default function DeferredTooltip({
  children,
  text,
  content,
  disabled = false,
  delay,
  ...tooltipProps
}) {
  if (Children.count(children) !== 1) {
    return children;
  }

  const onlyChild = Children.only(children);

  if (!isValidElement(onlyChild)) {
    return onlyChild;
  }

  return (
    <Tooltip
      text={text}
      content={content}
      delay={delay}
      disabled={disabled}
      {...tooltipProps}
    >
      {onlyChild}
    </Tooltip>
  );
}
